import { useEffect, useState } from 'react'
import { Checkbox, Input, Select, Tooltip } from 'antd'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import FormLikeField from './FormLikeField'
import ConditionalRenderingRules from './ConditionalRenderingRules'

ConditionalRendering = ({ fieldKey }) ->

  [{ fieldData }, dispatch] = useCreateMacroData()
  [isActive, setIsActive] = useState(false)
  [rules, setRules] = useState(undefined)

  useEffect( ->
    setIsActive(fieldData[fieldKey]?.config?.conditions)
    undefined
  , [fieldKey])

  setConditions = (value) ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, 'config', 'conditions'], value)
      )
    )

  <>
    <FormLikeField label="Conditions?">
      <Checkbox
        checked={isActive}
        onChange={({ target: { checked }}) ->
          setIsActive(checked)
          unless checked
            setConditions(undefined)
        }
      />
    </FormLikeField>
    { if isActive

      <ConditionalRenderingRules
        value={fieldData[fieldKey]?.config?.conditions}
        onChange={setConditions}
      />
    }
  </>

export default ConditionalRendering